// landIeul: components/Home/Samples/{Examples/Example,Experiences/Experience} をクライアント側で組むための共通処理。
// UseCaseSection / ExperienceSection が GraphQL 取得結果からカードを生成するのに使う。

export const NO_IMAGE_PATH = "/item/no_image.png";
const MAX_TITLE_LENGTH = 28;

// landIeul: components/uiParts/UtilizationMethodLabel の landUtilizationMethodMappings。
// キーは GraphQL enum (BrandLandUtilizationMethod) のシリアライズ値 = 大文字スネークケース。
const UTILIZATION_METHOD_LABELS: Record<string, string> = {
  APART: "アパート",
  MANSION: "マンション",
  HOUSES_FOR_RENT: "賃貸併用住宅",
  HOUSE: "戸建賃貸",
  COMMERCIAL_FACILITY: "商業施設",
  LARGE_FACILITY: "大規模施設",
  ELDERLY_FACILITY: "高齢者向け施設",
  PARKING: "駐車場",
  OTHER: "その他",
};

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function truncateTitle(title: string): string {
  if (!title) return "";
  return title.length > MAX_TITLE_LENGTH ? `${title.slice(0, MAX_TITLE_LENGTH)}...` : title;
}

export function utilizationLabelsHtml(methods: string[]): string {
  return (methods || [])
    .map((method) => {
      const label = UTILIZATION_METHOD_LABELS[method] || "";
      return `<span class="UtilizationMethodLabel_newLabel UtilizationMethodLabel_available">${escapeHtml(label)}</span>`;
    })
    .join("");
}
